import { Button } from 'primereact/button';
import { useCanGoBack, useRouter } from '@tanstack/react-router';
import { commonStrings } from '../../i18n';

export function BackButton() {
  const router = useRouter();
  const canGoBack = useCanGoBack();
  return (
    <Button
      label={commonStrings.words.back}
      icon="pi pi-arrow-left"
      text
      disabled={!canGoBack}
      onClick={() => router.history.back()}
    />
  );
}

export default BackButton;
